// Static data for the Shower Glass Designer

export const enclosureTypes = [
  { id: 'single-door', name: 'Single Door', description: 'Simple single panel door', panels: 1 },
  { id: 'door-panel', name: 'Door + Panel', description: 'Door with fixed side panel', panels: 2 },
  { id: 'door-two-panels', name: 'Door + 2 Panels', description: 'Door with panels on both sides', panels: 3 },
  { id: '90-degree', name: '90° Corner', description: 'Corner enclosure with door', panels: 2 },
  { id: 'neo-angle', name: 'Neo Angle', description: 'Angled corner enclosure', panels: 3 },
  { id: 'sliding', name: 'Sliding Door', description: 'Space-saving sliding design', panels: 2 },
];

export const glassTypes = [
  { id: 'clear', name: 'Clear', description: 'Crystal clear transparency' },
  { id: 'low-iron', name: 'Low-Iron Clear', description: 'Ultra-clear, no green tint' },
  { id: 'rain', name: 'Rain Glass', description: 'Textured rain pattern for privacy' },
  { id: 'frosted', name: 'Frosted', description: 'Obscured for maximum privacy' },
  { id: 'gray', name: 'Gray Tinted', description: 'Subtle gray tint' },
  { id: 'bronze', name: 'Bronze Tinted', description: 'Warm bronze tone' },
];

export const glassThicknesses = [
  { id: '3/8', name: '3/8"', description: 'Standard thickness' },
  { id: '1/2', name: '1/2"', description: 'Premium thickness' },
];

export const hardwareFinishes = [
  { id: 'chrome', name: 'Chrome', color: '#C0C0C0' },
  { id: 'brushed-nickel', name: 'Brushed Nickel', color: '#9A9A9A' },
  { id: 'matte-black', name: 'Matte Black', color: '#1a1a1a' },
  { id: 'oil-rubbed-bronze', name: 'Oil Rubbed Bronze', color: '#3D2314' },
  { id: 'gold', name: 'Gold/Brass', color: '#D4AF37' },
];

export const handleStyles = [
  { id: 'ladder', name: 'Ladder Pull' },
  { id: 'square', name: 'Square Pull' },
  { id: 'round', name: 'Round Pull' },
  { id: 'knob', name: 'Knob' },
];

export const coatingOptions = [
  { id: 'none', name: 'Standard Glass', description: 'No protective coating' },
  { id: 'showerguard', name: 'ShowerGuard®', description: 'Permanent protective coating - recommended' },
];

export const STEPS = [
  { id: 1, name: 'Enclosure', label: 'Type' },
  { id: 2, name: 'Dimensions', label: 'Size' },
  { id: 3, name: 'Glass', label: 'Glass' },
  { id: 4, name: 'Hardware', label: 'Hardware' },
  { id: 5, name: 'Submit', label: 'Contact' },
];

export const DEFAULT_CONFIG = {
  enclosureType: '',
  hingePosition: 'left',
  doorPosition: 'left',
  dimensions: { width: '', height: '72', panelWidth: '', doorWidth: '28', side1: '', front: '', side2: '' },
  glassType: 'clear',
  glassThickness: '3/8',
  coating: 'none',
  hardwareFinish: 'chrome',
  handleStyle: 'ladder',
  additionalNotes: '',
  isComplex: false,
  contact: { name: '', email: '', phone: '', address: '', preferredContact: 'email', timeline: '' },
};
